<div class="video-container">
	<iframe [src]="videoUrl" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
</div>
